import React from "react";

interface SponsorProps {
  details?: any;
}

export default function Sponsor({ details }: SponsorProps) {
  return (
    <div className="sponsor-com-img-wrap">
      <span>Sponsored by:</span>
      <a>
        <img src={details?.original || "/images/sponsorLogo.png"} alt="Sponsor Image" />
      </a>
    </div>
  );
}
